import { render, staticRenderFns } from "./ButtonReturn.vue?vue&type=template&id=4fc7e328"
import script from "./ButtonReturn.vue?vue&type=script&lang=js"
export * from "./ButtonReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports